import type { SvgIconComponent } from '@mui/icons-material';
import InfoOutlined from '@mui/icons-material/InfoOutlined';
import WarningAmberOutlined from '@mui/icons-material/WarningAmberOutlined';
import CheckCircleOutline from '@mui/icons-material/CheckCircleOutline';
import ErrorOutline from '@mui/icons-material/ErrorOutline';
import LightbulbOutlined from '@mui/icons-material/LightbulbOutlined';

export type CalloutVariant = 'info' | 'warning' | 'success' | 'danger' | 'tip';

export interface CalloutVariantStyle {
    icon: SvgIconComponent;
    /** Tinted surface, border and text colours. No gradients (design rule). */
    background: string;
    border: string;
    color: string;
    iconColor: string;
}

/**
 * Colours of the callout (Hinweisbox) variants, shared by editor node view and
 * player so both render the same box. Uses the warn tokens of the design system
 * for `warning` and flat tints for the rest.
 */
export const CALLOUT_VARIANTS: Record<CalloutVariant, CalloutVariantStyle> = {
    info: { icon: InfoOutlined, background: '#eef4fb', border: '#c8dbf0', color: '#163a5f', iconColor: '#2f6db5' },
    warning: {
        icon: WarningAmberOutlined,
        background: 'var(--oa-warn-surface, #fff6d6)',
        border: 'var(--oa-warn-border, #f0d98a)',
        color: 'var(--oa-warn-on-surface, #5c4a00)',
        iconColor: 'var(--oa-warn-fg, #a67c00)',
    },
    success: { icon: CheckCircleOutline, background: '#eaf6ee', border: '#bfe3cb', color: '#1d4d2b', iconColor: '#2e8b57' },
    danger: { icon: ErrorOutline, background: '#fdeeee', border: '#f2c4c4', color: '#6b1d1d', iconColor: '#c62828' },
    tip: { icon: LightbulbOutlined, background: '#f3effa', border: '#d9cdf0', color: '#3d2a66', iconColor: '#6a4fb3' },
};

export const CALLOUT_VARIANT_KEYS: CalloutVariant[] = ['info', 'warning', 'success', 'danger', 'tip'];

export function getCalloutVariant(variant: string | undefined): CalloutVariantStyle {
    return (variant ? CALLOUT_VARIANTS[variant as CalloutVariant] : undefined) ?? CALLOUT_VARIANTS.info;
}
